import { render, staticRenderFns } from "./EditLog.vue?vue&type=template&id=3b9d4dbe&scoped=true"
import script from "./EditLog.vue?vue&type=script&lang=js"
export * from "./EditLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9d4dbe",
  null
  
)

export default component.exports